exports.getPlanData = ({ plan, locale = 'en' }) => {
  let interval;
  let nextPaymentDays = 0;
  let intervalDays = 0;
  let description;
  let productName;
  let product;
  let period;
  let emailPlanName;
  let periodWithTrial;
  let rebillProductName;
  switch (true) {
    // eslint-disable-next-line
    case plan?.trialDays == 14:
      interval = '30 days';
      nextPaymentDays = 14;
      intervalDays = 30;
      description = '2 week trial';
      productName = '14 days trial plan';
      product = '2 Week trial';
      periodWithTrial = 'trial';
      rebillProductName = 'MONTHLY ACCESS';
      break;
    // eslint-disable-next-line
    case plan?.trialDays == 30:
      interval = '365 days';
      nextPaymentDays = 30;
      intervalDays = 365;
      description = '1 month trial';
      productName = '30 days trial plan';
      product = '1 Month trial';
      periodWithTrial = 'trial';
      rebillProductName = 'YEARLY ACCESS';
      break;
    // eslint-disable-next-line
    case plan?.billingCycle?.value == 7:
      interval = '7 days';
      nextPaymentDays = 7;
      intervalDays = 7;
      description = 'Weekly Plan';
      productName = 'PREMIUM WEEKLY ACCESS';
      product = 'Weekly no trial';
      periodWithTrial = 'weekly';
      rebillProductName = 'WEEKLY ACCESS';
      break;
    // eslint-disable-next-line
    case plan?.billingCycle?.value == 365:
      interval = '365 days';
      nextPaymentDays = 365;
      intervalDays = 365;
      description = 'Yearly Plan';
      productName = 'PREMIUM YEARLY ACCESS';
      product = 'Yearly no trial';
      periodWithTrial = 'yearly';
      rebillProductName = 'YEARLY ACCESS';
      break;
    // eslint-disable-next-line
    case plan?.billingCycle?.value == 90:
      interval = '90 days';
      nextPaymentDays = 90;
      intervalDays = 90;
      description = 'Quarterly Plan';
      productName = 'PREMIUM QUARTERLY ACCESS';
      product = 'Quarterly no trial';
      periodWithTrial = 'quarterly';
      rebillProductName = 'QUARTERLY ACCESS';
      break;
    default:
      interval = '30 days';
      nextPaymentDays = 30;
      intervalDays = 30;
      description = 'Monthly Plan';
      productName = 'PREMIUM MONTHLY ACCESS';
      product = 'Monthly no trial';
      periodWithTrial = 'monthly';
      rebillProductName = 'MONTHLY ACCESS';
      break;
  }
  return {
    interval,
    nextPaymentDays,
    intervalDays,
    description,
    productName,
    product,
    period,
    emailPlanName,
    periodWithTrial,
    rebillProductName,
  };
};
